"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Layer = _interopRequireDefault(require("./Layer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/* eslint-disable spaced-comment */
///<reference path="../../../../../../node_modules/@types/leaflet/index.d.ts" />

/* eslint-enable spaced-comment */


var LeafletPolylineLayer =
/** @class */
function (_super) {
  __extends(LeafletPolylineLayer, _super);

  function LeafletPolylineLayer(layer, points, opts, id) {
    if (opts === void 0) {
      opts = undefined;
    }

    if (id === void 0) {
      id = undefined;
    }

    var _this = _super.call(this, layer, opts, id) || this;

    _this._points = points;
    return _this;
  }

  LeafletPolylineLayer.prototype.setOpacity = function (value) {
    _super.prototype.setOpacity.call(this, value);

    if (this.renderable) {
      this.renderable.setStyle(__assign(__assign({}, this.opts), {
        opacity: value
      }));
    }
  };

  LeafletPolylineLayer.prototype.createRenderable = function () {
    var _this = this;

    var renderable = L.polyline(this._points, this.opts);
    renderable.on('click', function () {
      return _this.trigger('click', {
        polyline: _this
      });
    });
    return renderable;
  };

  return LeafletPolylineLayer;
}(_Layer.default);

var _default = LeafletPolylineLayer;
exports.default = _default;
module.exports = exports.default;